




























import {Component, Vue, Watch} from "vue-property-decorator";
import TestimonialForm from '@/components/TestimonialForm.vue'

enum State {
    LOADING,
    INITIALIZED,
    NOT_FOUND,
    PREVIOUSLY_SUBMITTED,
    SUCCESS,
}

@Component({name: "Testimonial", components: {TestimonialForm}})
export default class Testimonial extends Vue {

    private state!: State;

    private get States() { return State }

    private created() {
        this.state = this.States.LOADING;
    }

    private initialize() {
        this.state = this.States.INITIALIZED;
        this.$forceUpdate();
    }
}
